# IS THIS A MOBILE DEVICE? — card 6ac022cba664bc34d57be8c7 (owner design
# 2026-10-02, umbrella decision D).
#
# Mobile means the DEVICE, not only the native shell:
#
#   - the native apps: isApp() — the iOS bridge, or the Android shell
#     (loopback_api.coffee);
#   - mobile web: a phone or tablet by its user agent, isTouchDevice() (bowser's
#     platform type 'mobile' or 'tablet');
#   - a home-screen WEBCLIP, so that a webclip behaves just like the app:
#     standalone display mode (navigator.standalone on iOS,
#     matchMedia('(display-mode: standalone)') elsewhere) ON A TOUCH SCREEN.
#     The touch half is what tells an iPad apart: iPadOS sends a desktop
#     Safari user agent, so the user-agent arm misses it, but a webclip on it is
#     standalone with five touch points. An installed desktop PWA is standalone
#     with none, and stays desktop.
#
# A device that is mobile here hosts the mobile App row and lands on its
# dashboard; anything else never fetches it and behaves exactly as before.
#
# IMPORT-FREE ON PURPOSE: a pin drives it with a stub app and window.

export isStandalone = (win) ->
  try
    return true if win?.navigator?.standalone is true
    return !!win?.matchMedia?('(display-mode: standalone)')?.matches
  catch
    false

export hasTouchScreen = (win) ->
  try
    Number(win?.navigator?.maxTouchPoints ? 0) > 1
  catch
    false

# PHONES ONLY (owner 2026-10-05: the Mobile UI "was not supposed to show on
# iPad"). Every arm above also matches a tablet — the iPad app, a tablet's
# user agent, an iPad webclip — so the device must also be PHONE-SIZED: the
# screen's shorter side under 600 CSS px, either way up. Phones are 320–440;
# the smallest iPad is 744 and Android tablets start at 600. No screen to read
# (a stub, an old shell) keeps the arms' answer.
PHONE_MAX_SHORT_SIDE = 600
export isPhoneSized = (win) ->
  try
    w = Number(win?.screen?.width ? win?.innerWidth)
    h = Number(win?.screen?.height ? win?.innerHeight)
    return true unless w > 0 and h > 0
    Math.min(w, h) < PHONE_MAX_SHORT_SIDE
  catch
    true

export isMobileDevice = (app, win) ->
  mobile = app?.isApp?() or app?.isTouchDevice?() or (isStandalone(win) and hasTouchScreen(win))
  !!mobile and isPhoneSized(win)

# CLASSIC VIEW — owner 2026-10-03: "an override. Like 'Classic View' vs 'New
# Mobile View' so if we are seeing mobile the menu says classic view and sends
# us back to the old screen". The choice belongs to the DEVICE (this browser's
# storage), not the account: a parent may want the new view on a phone and the
# classic one on an iPad. Classic makes a mobile device behave exactly as if
# no mobile App were named — the built-in screens, byte for byte. The default,
# with nothing stored or storage refused, is the new mobile view.
#
# The mobile Shell row's menu offers "Classic View" through
# window.app.setMobileView('classic'); the classic title bar's drawer offers
# "New Mobile View" (title_bar.coffee) wherever the mobile view is available.
export VIEW_KEY = 'el-mobile-view'

export classicChosen = (win) ->
  try
    win?.localStorage?.getItem(VIEW_KEY) == 'classic'
  catch
    false

# Store the choice and reload on the landing screen, so the router is built
# again for the chosen view. 'classic' stores; anything else clears.
export setMobileView = (view, win) ->
  try
    if view == 'classic'
      win.localStorage.setItem VIEW_KEY, 'classic'
    else
      win.localStorage.removeItem VIEW_KEY
  catch
    return false
  win.location.replace "#{win.location.pathname}#{win.location.search}"
  true

# ?classic=true / ?classic=false IN THE ADDRESS SETS THE CHOICE — owner
# 2026-10-03: "Classic = true/false no matter what if it's there then we set
# it". Read from the query or the hash's query (/app?classic=true,
# /app#/dashboard?classic=false), stored before the routes are built, and
# taken out of the address bar so a bookmark or a shared link does not carry
# it. Any other value is ignored.
export CLASSIC_PARAM = /([?&])classic=(true|false)(&|$)/i

export applyClassicParam = (win) ->
  try
    loc = win.location
    for part in ['search', 'hash']
      m = String(loc[part] ? '').match CLASSIC_PARAM
      continue unless m?
      if m[2].toLowerCase() == 'true'
        win.localStorage.setItem VIEW_KEY, 'classic'
      else
        win.localStorage.removeItem VIEW_KEY
      search = String(loc.search ? '').replace(CLASSIC_PARAM, (all, lead, v, tail) -> if tail then lead else '').replace(/^\?$/, '')
      hash = String(loc.hash ? '').replace(CLASSIC_PARAM, (all, lead, v, tail) -> if tail then lead else '').replace(/\?$/, '')
      win.history?.replaceState?(win.history.state, '', "#{loc.pathname}#{search}#{hash}")
      return m[2].toLowerCase() == 'true'
  catch
    null
  null
